/** Réalité augmentée :
 *  - iOS : AR Quick Look avec product.ar.usdz, sinon export USDZ à la volée du modèle affiché
 *  - Android : Scene Viewer avec product.ar.glb (URL https absolue requise)
 *  - ordinateur : renvoie 'desktop' (à l'appelant d'afficher un QR code / un message) */
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isAndroid = () => /Android/i.test(navigator.userAgent);

export async function launchAR(product, root) {
  const ar = product.ar || {};
  if (isIOS()) {
    let href = ar.usdz;
    if (!href && root) {
      const { USDZExporter } = await import('three/addons/exporters/USDZExporter.js');
      const data = await new USDZExporter().parseAsync(root);
      href = URL.createObjectURL(new Blob([data], { type: 'model/vnd.usdz+zip' }));
    }
    if (!href) return 'unavailable';
    const a = document.createElement('a'); a.rel = 'ar'; a.href = href;
    a.appendChild(document.createElement('img')); a.click(); return 'ios';
  }
  if (isAndroid() && ar.glb) {
    const file = new URL(ar.glb, location.href).href;
    const title = encodeURIComponent(product.name || '');
    location.href = `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(file)}&mode=ar_preferred&title=${title}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(location.href)};end;`;
    return 'android';
  }
  return isAndroid() ? 'unavailable' : 'desktop';
}
